import * as React from 'react';

import userDropdownArrow from '../../assets/images/user-dropdown-arrow.svg';
import { Avatar } from '../../atoms/Avatar';
import { cn } from '../../lib/utils';

export interface UserMenuTriggerProps {
  initials: string;
  email: string;
  /** Whether the associated popover is open. Rotates the chevron when true. */
  open: boolean;
  onClick: () => void;
  className?: string;
  /** Forwarded to the root button element for consumer-defined test targeting. */
  'data-testid'?: string;
}

export const UserMenuTrigger = React.forwardRef<HTMLButtonElement, UserMenuTriggerProps>(
  ({ initials, email, open, onClick, className, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        data-testid={rest['data-testid']}
        onClick={onClick}
        aria-haspopup="menu"
        aria-expanded={open}
        className={cn(
          'flex items-center gap-2 hover:opacity-80 transition-opacity duration-150 cursor-pointer',
          className
        )}
      >
        <Avatar size="xs" initials={initials} />
        <span className="text-[12px] font-normal text-dawn-black font-outfit leading-[1.4]">
          {email}
        </span>
        <img
          src={userDropdownArrow}
          alt=""
          className={cn('w-[8px] h-[8px] transition-transform duration-200', open && 'rotate-180')}
        />
      </button>
    );
  }
);

UserMenuTrigger.displayName = 'UserMenuTrigger';
